import { render, staticRenderFns } from "./UnComplateNew.vue?vue&type=template&id=39e214e8&scoped=true&"
import script from "./UnComplateNew.vue?vue&type=script&lang=js&"
export * from "./UnComplateNew.vue?vue&type=script&lang=js&"
import style0 from "./UnComplateNew.vue?vue&type=style&index=0&id=39e214e8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39e214e8",
  null
  
)

export default component.exports